import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";

const divRoot: HTMLDivElement = document.querySelector("#ko-change-password");
const divModel: HTMLDivElement = document.querySelector("#divUserChangePasswordModel");

export class ViewModel {
    busy = ko.observable(false);

    current = ko.observable<string>();
    password = ko.observable<string>();
    confirm = ko.observable<string>();

    submit: () => void

    constructor() {
        let self = this;

        self.busy.subscribe(newVal => App.busy(newVal));

        self.submit = () => {
            if (!self.busy() && self.validate())
                self.save();
        }
    }

    private save() {
        let self = this;

        self.busy(true);

        var data = {
            current: self.current(),
            password: self.password()
        }

        Api.ChangePassword(data)
            .done(results => {
                if (results.error) { App.alertWarning(results.message); return; }
                window.location.href = results.nextUrl;
            })
            .always(() => self.busy(false));
    }

    private validate(): boolean {
        let self = this;

        if (!App.validatePassword(self.password())) { App.alertWarning("Invalid Password"); return false; }
        if (self.password() !== self.confirm()) { App.alertWarning("Passwords are different"); return false; }

        return true;
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(), divRoot);
    }
}

$(document).ready(() => init());